/**
 * Updates the collection title and subtitle elements with sale information.
 * - Gets sale title and end date from data attributes.
 * - Splits sale title into title and discount text.
 * - Sets title and subtitle elements.
 * - Formats end date.
 * - Runs on timeout to wait for data.
 */
// function currentSalesTitle() {
//   if (document.querySelector('[data-name="json-output-message"]') && document.querySelector('[data-name="json-output-message"]').textContent !== "Take a look at the sale") {
//     const jsonCollectionTitle = document.querySelectorAll('[data-name="dynamic-collection-title"]');
//     const jsonDateTo = new Date(document.querySelector('[data-name="date-to"]').textContent);
//     const title = document.querySelector('[data-name="json-output-message"]').textContent;
//     const [saleTitle, discountText] = title.split(" | ");

//     const percentageInputContainer = document.querySelector('[data-name="dynamic-collection-discount"]');
//     const dateInputContainer = document.querySelector('[data-name="dynamic-collection-date"]');

//     jsonCollectionTitle.forEach((title) => {
//       title.textContent = saleTitle;
//     })
//     jsonDateTo.setDate(jsonDateTo.getDate() - 1);

//     const jsonDateToFormatted = jsonDateTo.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
//     const percentageRegex = /\b\d{1,2}(?:\.\d+)?%/;

//     const percentageDiscount = discountText.match(percentageRegex);
//     percentageInputContainer.textContent = percentageDiscount;
//     dateInputContainer.textContent = jsonDateToFormatted.replace("/", ".") + "!";;
//   }
// }

/**
 * Updates sale description with data from announcement bar
 * - Gets date from window.noomaAnnouncementData
 * - Updates #sale-date-value element and shows/hides the wrapper
 * - Shows "Only until [date]" if countdown is enabled, otherwise hides it
 */
function updateSaleDescription() {
  const dateWrapper = document.getElementById('sale-date-wrapper');
  const dateValue = document.getElementById('sale-date-value');

  if (!dateWrapper || !dateValue) return;

  // Check if announcement data is available and countdown is enabled
  if (window.noomaAnnouncementData && window.noomaAnnouncementData.showCountdown && window.noomaAnnouncementData.endDate) {
    dateValue.textContent = window.noomaAnnouncementData.endDate;
    dateWrapper.style.display = 'inline';
  } else {
    // Hide wrapper when countdown is disabled
    dateWrapper.style.display = 'none';
  }
}
updateSaleDescription();


// setTimeout(() => {
//   // currentSalesTitle();
//   updateSaleDescription();
// }, 250);
